import React from "react";
import "../layout/Spinner.css";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import { Loader } from "semantic-ui-react";
import AthleteEvents from "./AthleteEvents";
import "./AthleteCoachList.css";

const AthleteEventsList = (props) => {
  if (isLoaded(props.athleteEvents)) {
    return <AthleteEvents events={props.athleteEvents} />;
  } else {
    return (
      <div className="SpinnerBackground">
        <div className="SpinnerContainer">
          <Loader size="large" active inline="centered" />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state, ownProps) => {
  const athleteEvents = [];
  let events = [];
  const EventsData = state.firestore.data.events;
  if (EventsData) {
    const eventsId = Object.keys(EventsData);
    eventsId.forEach((eventId) => {
      if (EventsData[eventId]) {
        if (
          EventsData[eventId].eventAttenders.includes(ownProps.id) &&
          EventsData[eventId].eventStatus
        ) {
          athleteEvents.push(EventsData[eventId]);
        }
      }
    });
  }
  if (athleteEvents.length > 0) {
    events = athleteEvents.map((event) => {
      let attenders = event.eventAttenders;
      attenders = attenders.map((visitor) => {
        const person = {};
        if (visitor in state.firestore.data.athleteEventsListRef) {
          person.name =
            state.firestore.data.athleteEventsListRef[visitor].firstName +
            " " +
            state.firestore.data.athleteEventsListRef[visitor].lastName;
          person.image =
            state.firestore.data.athleteEventsListRef[visitor].thumbnail;
          person.id = visitor;
          person.customUrl =
            state.firestore.data.athleteEventsListRef[visitor].customUrl;
          person.extraData = state.firestore.data.athleteEventsListRef[visitor];
        } else if (visitor in state.firestore.data.advocates) {
          person.name = state.firestore.data.advocates[visitor].name;
          person.image = state.firestore.data.advocates[visitor].thumbnailUrl;
          person.id = visitor;
          person.customUrl = state.firestore.data.advocates[visitor].customUrl;
        }
        return person;
      });
      return { ...event, attenders };
    });
    events = events.sort(
      (date1, date2) => date1.eventStartDate - date2.eventStartDate
    );
  }
  return {
    athleteEvents: events,
  };
};
export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "advocates",
    },
    {
      collection: "userRole",
    },
    {
      collection: "events",
    },
    {
      collection: "adminAthletes",
      storeAs: "athleteEventsListRef",
    },
  ])
)(AthleteEventsList);
